<template>
    <div>
        <SrInput v-bind="attrs" v-on="$listeners" />
        <VDivider />
    </div>
</template>

<script>
import { SrInput } from '../SrInput';

const ELEMENT_CLASS = 'sr-select-search';

export default {
    name: 'SrSelectSearch',
    components: { SrInput },
    computed: {
        classList() {
            return [ELEMENT_CLASS];
        },
        attrs() {
            return {
                prependInnerIcon: 'mdi-magnify',
                placeholder: 'Search',
                class: this.classList,
                outlined: false,
                autofocus: true,
                clearable: true,
                solo: true,
                flat: true,
                ...this.$attrs,
            };
        },
    },
};
</script>
